import Swiper from 'swiper'

export default class NewsCarousel {
  constructor(el) {
    this.el = el
    this.$el = $(this.el)

    const options = {
      loop: true,
      slidesPerView: 1,
          slidesPerGroup: 1,
      speed: 500,
      watchOverflow: true,
      autoplay: {
        delay: this.$el.data('autoplay'),
      },
      navigation: {
        nextEl: this.$el.find('.c-news-carousel__btn--next'),
        prevEl: this.$el.find('.c-news-carousel__btn--prev'),
      },
    }

    new Swiper(this.el, options)
  }
}
